import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionProviderEarlyCancel = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = getFirstName(get(user, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      date={transition.createdAt}
      direction="left"
      header={
        isOwnTransition ? (
          <FormattedMessage id="BookingStatus.ownProviderCancelEarly" values={{ displayName }} />
        ) : (
          <FormattedMessage
            id="BookingStatus.transitionProviderCancelEarly"
            values={{ displayName }}
          />
        )
      }
      buttons={buttons}
    >
      {isOwnTransition ? (
        <FormattedMessage
          id="BookingStatus.ownProviderCancelEarlySubtext"
          values={{ displayName }}
        />
      ) : (
        <FormattedMessage
          id="BookingStatus.transitionProviderCancelEarlySubtext"
          values={{ displayName }}
        />
      )}
    </InboxTransitionBase>
  );
};

export default InboxTransitionProviderEarlyCancel;
